import { render, staticRenderFns } from "./Selfie.vue?vue&type=template&id=641750fa&scoped=true&"
import script from "./Selfie.vue?vue&type=script&lang=js&"
export * from "./Selfie.vue?vue&type=script&lang=js&"
import style0 from "./Selfie.vue?vue&type=style&index=0&id=641750fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641750fa",
  null
  
)

export default component.exports